import { motion } from "framer-motion";

const STEPS = [
  { key: "attention", label: "Attention", letter: "A" },
  { key: "witness", label: "Witness", letter: "W" },
  { key: "align", label: "Align", letter: "A" },
  { key: "kata", label: "Kata", letter: "K" },
  { key: "evolve", label: "Evolve", letter: "E" },
];

export default function AwakeLoop({ activeIndex = -1 }) {
  return (
    <section
      className="max-w-3xl mx-auto px-2 py-12"
      data-testid="awake-loop"
      aria-label="AWAKE framework progress"
    >
      <div className="relative">
        {/* horizontal connector line */}
        <div
          className="absolute left-4 right-4 top-1/2 -translate-y-1/2 h-px"
          style={{
            background:
              "linear-gradient(to right, transparent, rgba(74,160,164,0.35), transparent)",
          }}
          aria-hidden="true"
        />

        <ol className="relative grid grid-cols-5 gap-2 md:gap-4">
          {STEPS.map((step, idx) => {
            const isActive = idx === activeIndex;
            const isDone = activeIndex > idx;
            return (
              <li
                key={step.key}
                className="flex flex-col items-center text-center"
                data-testid={`awake-node-${step.key}`}
              >
                <motion.div
                  initial={false}
                  animate={{
                    scale: isActive ? 1.08 : 1,
                  }}
                  transition={{ duration: 0.4 }}
                  className="relative flex items-center justify-center"
                >
                  <span
                    className="flex items-center justify-center rounded-full text-sm font-medium"
                    style={{
                      width: 40,
                      height: 40,
                      background: isActive
                        ? "#4aa0a4"
                        : isDone
                        ? "rgba(74,160,164,0.12)"
                        : "#ffffff",
                      color: isActive
                        ? "#ffffff"
                        : isDone
                        ? "#3c8386"
                        : "#94a3b8",
                      border: isActive
                        ? "1px solid #4aa0a4"
                        : "1px solid #e2e8f0",
                      transition: "all 300ms ease",
                    }}
                  >
                    {step.letter}
                  </span>
                </motion.div>
                <span
                  className="mt-3 text-[11px] md:text-xs uppercase tracking-[0.18em] font-medium"
                  style={{
                    color: isActive
                      ? "#3c8386"
                      : isDone
                      ? "#475569"
                      : "#94a3b8",
                  }}
                >
                  {step.label}
                </span>
              </li>
            );
          })}
        </ol>
      </div>
    </section>
  );
}
